<template>
		<div class="game-iframe-page">
        <a class="game-iframe-back" @click="back"><img src="../../static/images/livequiz/back.png" alt="" /></a>
      <iframe class="iframe" :src="url"></iframe>
		</div>
</template>
<script>
import Header from '../components/HeaderOne'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
    Dialog
    },
    data() {
      return {
       isShow:null,
       info:{},
        url:null
      }
    },
	created(){
    this.getUrl()
	},
  methods: {
		back(){
			this.$router.go(-1);
		},
    getUrl(){
       let that = this
       that.$parent.loadModal(true);
       let data = {
          game_id:this.$route.query.game_id
       }
       that.$api.post('/api/game/go',data,r =>{
         that.url = r.data.url
         that.$parent.loadModal(false);
       })
    },
	}
}
</script>
<style>
.game-iframe-page { position:relative; min-height:100vh; overflow:hidden; background:#06021d url('../../static/images/livequiz/main_bg.jpg') center top/100% 100% no-repeat; }
.game-iframe-back { position:absolute; z-index:1520; top:20px; left:10px; display:block; width:80px; height:80px; cursor:pointer; }
.game-iframe-back img { display:block; width:100%; height:100%; object-fit:contain; }
.empty-message {
  padding: 100px 0;
  font-size: 24px;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/page/gameIframe.vue